// eslint-disable-next-line no-restricted-imports
import { css } from "@emotion/react";

import { token } from "@atlaskit/tokens";
import { getMediaDown, getMediaUp } from "@atlassiansox/wpl-utils";

export const rootContainerStyle = css`
    position: relative;
    background-color: ${token("elevation.surface", "#22272B")};
    border-radius: 10px;
    height: 736px;
    padding: 26px 18px;
    overflow: visible;
`;

export const jswInteractiveBoardDisplay = css`
    ${getMediaDown("lg")} {
        display: none;
    }
`;

export const imageDisplay = css`
    ${getMediaUp("lg")} {
        display: none;
    }
`;

export const boardHeaderStyle = css`
    margin-bottom: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const rightButtonGroupStyle = css`
    display: flex;
`;

export const leftButtonGroupStyle = css`
    display: flex;
    justify-content: space-between;
    gap: 24px;
`;

export const buttonDividerStyle = css`
    background-color: ${token("color.icon")};
    margin-left: 16px;
    margin-right: 4px;
    width: 1px;
`;

export const rotateRestartButtonStyle = css`
    :hover svg,
    :focus svg {
        transform: rotate(90deg);
    }
    svg {
        transition: 0.3s;
        @media screen and (prefers-reduced-motion: reduce) {
            transition: none;
        }
    }
`;

export const wiggleCreateButtonStyle = css`
    @keyframes hiThere {
        15% {
            transform: scale(1.2);
        }
        20%,
        30% {
            transform: rotate(-20deg) scale(1.2);
        }
        25% {
            transform: rotate(20deg) scale(1.2);
        }
        35% {
            transform: rotate(0deg) scale(1.2);
        }
        50% {
            transform: scale(1);
        }
    }
    animation: 2.3s ease hiThere infinite;
    @media screen and (prefers-reduced-motion: reduce) {
        animation: none;
    }
`;

export const fadeInRestartButtonStyle = css`
    @keyframes fadeIn {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
    opacity: 0;
    animation: 1s ease-in fadeIn 500ms forwards;

    @media screen and (prefers-reduced-motion: reduce) {
        animation-duration: 4s;
    }
`;

export const boardBodyStyle = css`
    border-radius: 8px;
    height: calc(100% - 56px);
    overflow-y: auto;
`;

export const columnContainerStyle = css`
    display: flex;
    gap: 12px;
    min-height: 100%;
`;

export const columnTitleStyle = css`
    background-color: ${token("elevation.surface.sunken", "#161A1D")};
    color: ${token("color.text.subtle", "#9FADBC")};
    display: block;
    font-size: 12px;
    font-weight: 600;
    padding: 16px;
    text-transform: uppercase;
    margin: 0px;
    line-height: 1.33333333;
`;

export const columnStyle = css`
    background-color: ${token("elevation.surface.sunken", "#161A1D")};
    border-radius: 8px;
    flex: 1 1 0;
    padding-left: 5px;
    padding-right: 5px;
    min-height: 622px;
`;
